export default "__VITE_ASSET__c216d8cc__"